import dayjs from 'dayjs';

const KEY_TAB = 9;
const KEY_END = 35;
const KEY_HOME = 36;
const KEY_ARROW_LEFT = 37;
const KEY_ARROW_UP = 38;
const KEY_ARROW_RIGHT = 39;
const KEY_ARROW_DOWN = 40;

const isBlackoutDay = (data, day) => {
  return data.filter((item) => day.isSame(item.day, 'day'))[0]?.fareItem?.isBlackoutDay;
};

const getNextDateAfterBlackoutDay = (data, day) => {
  return data.filter(
    (item) => dayjs(item.day).isAfter(day, 'day') && !item.fareItem.isBlackoutDay
  )[0];
};

const getNextDate = (newDate, oldDate, data) => {
  const fare = getNextDateAfterBlackoutDay(data, newDate);
  if (fare) {
    return dayjs(fare?.day);
  }
  return dayjs(oldDate);
};

export default function useA11y({ dispatch }) {
  const handleKeyboardNavigation = (date, event, firstday, focusDate, data) => {
    const firstDay = dayjs(firstday);
    const endDay = dayjs(firstday).add(2, 'month').endOf('month');
    let newDate;
    switch (event.keyCode) {
      case KEY_TAB: {
        if (event.shiftKey) {
          if (
            dayjs(date).isSame(new Date(), 'day') ||
            dayjs(date).isSame(dayjs(date).startOf('month'), 'day')
            // || (state.selectedComponent === 'end' && dayjs(date).isSame(firstDay, 'day'))
          ) {
            return;
          }
          newDate = dayjs(focusDate).subtract(1, 'day');
          if (
            newDate.isBefore(endDay) &&
            newDate.isAfter(firstDay) &&
            isBlackoutDay(data, newDate)
          ) {
            newDate = getNextDate(newDate, focusDate, data);
          }
        } else {
          if (dayjs(date).isSame(dayjs(date).endOf('month'), 'day')) {
            return;
          }
          newDate = dayjs(focusDate).add(1, 'day');
          if (
            newDate.isBefore(endDay) &&
            newDate.isAfter(firstDay) &&
            isBlackoutDay(data, newDate)
          ) {
            newDate = getNextDate(newDate, focusDate, data);
          }
        }
        break;
      }
      case KEY_ARROW_RIGHT: {
        newDate = dayjs(focusDate).add(1, 'day');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(data, newDate)) {
          newDate = getNextDate(newDate, focusDate, data);
        }
        break;
      }
      case KEY_ARROW_LEFT: {
        newDate = dayjs(focusDate).subtract(1, 'day');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(data, newDate)) {
          newDate = getNextDate(newDate, focusDate, data);
        }
        break;
      }
      case KEY_ARROW_UP: {
        newDate = dayjs(focusDate).subtract(7, 'day');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(data, newDate)) {
          newDate = getNextDate(newDate, focusDate, data);
        }
        break;
      }
      case KEY_ARROW_DOWN: {
        newDate = dayjs(focusDate).add(7, 'day');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(data, newDate)) {
          newDate = getNextDate(newDate, focusDate, data);
        }
        break;
      }
      case KEY_HOME: {
        event.preventDefault();
        newDate = dayjs(date).startOf('week');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(data, newDate)) {
          newDate = getNextDate(newDate, focusDate, data);
        }
        break;
      }
      case KEY_END: {
        event.preventDefault();
        newDate = dayjs(date).endOf('week');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(data, newDate)) {
          newDate = getNextDate(newDate, focusDate, data);
        }
        break;
      }
      default: {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }
    if (
      newDate &&
      (firstDay.isSame(newDate.toDate(), 'day') ||
        endDay.isSame(newDate.toDate(), 'day') ||
        (firstDay.isBefore(newDate.toDate(), 'day') && endDay.isAfter(newDate.toDate(), 'day')))
    ) {
      dispatch({ type: 'SET_FOCUS_DATE', payload: newDate.toDate() });
      dispatch({ type: 'SET_AVOID_FOCUS_DATE_ACTION', payload: false });
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return { handleKeyboardNavigation };
}
